// Generated by backend/scripts/generate_blog_audio.py: per-post French items with an MP3.
export const BLOG_AUDIO = {
  "como-pedir-restaurante-frances-sem-vergonha": [
    "bonsoir-vous-avez-reserve",
    "bonjour-une-table-pour-deux-s-il-vous-plait",
    "bonjour",
    "une-table",
    "est-ce-que-vous-prenez-la-carte-de-credit",
    "est-ce-que-je-peux-voir-la-carte-s-il-vous-plait",
    "la-carte",
    "le-menu",
    "un-verre-de-vin-rouge-s-il-vous-plait",
    "un-verre",
    "un-pichet",
    "une-bouteille",
    "vin-rouge",
    "blanc",
    "rose",
    "qu-est-ce-que-vous-me-recommandez",
    "qu-est-ce-qu-il-y-a-dans-ce-plat",
    "blanquette-de-veau",
    "confit",
    "c-est-quoi-ca",
    "je-suis-allergique-aux-fruits-de-mer",
    "au-gluten",
    "aux-fruits-a-coque",
    "au-lactose",
    "je-voudrais-l-entree-numero-deux-et-le-plat-du-jour",
    "je-voudrais",
    "je-veux",
    "plat-du-jour",
    "saignant-a-point-ou-bien-cuit-s-il-vous-plait",
    "a-point",
    "bien-cuit",
    "saignant",
    "une-carafe-d-eau-s-il-vous-plait",
    "carafe-d-eau",
    "une-bouteille-d-eau",
    "est-ce-que-vous-avez-du-pain-s-il-vous-plait",
    "un-peu-plus-de-pain-s-il-vous-plait",
    "ce-plat-est-delicieux-mes-compliments-au-chef",
    "excusez-moi-s-il-vous-plait",
    "garcon",
    "excusez-moi",
    "s-il-vous-plait",
    "l-addition-s-il-vous-plait",
    "l-addition",
    "merci-beaucoup-c-etait-parfait-bonne-journee",
    "bonne-soiree",
    "bonne-journee",
    "c-etait-parfait",
    "c-etait-delicieux",
    "vous-etes-combien",
    "est-ce-que-je-peux-avoir-sans-tomate",
    "steak-tartare"
  ],
  "numeros-em-frances-guia-com-audio": [
    "quatre-vingts",
    "quatre-vingt-onze",
    "combien-ca-coute",
    "soixante-quinze-euros",
    "et-un",
    "septante",
    "huitante",
    "octante",
    "vingt-et-un",
    "ca-fait-combien",
    "douze-euros-cinquante",
    "cinquante",
    "cinquante-centimes",
    "vous-avez-quel-age",
    "j-ai-trente-cinq-ans",
    "ans",
    "zero-six-douze-trente-quatre-cinquante-six-soixante-dix-huit",
    "le-15-mars",
    "premier"
  ],
  "frances-franca-vs-quebec": [
    "moi",
    "chien",
    "tu",
    "vous",
    "on-peut-se-tutoyer",
    "voiture",
    "petit-e-ami-e",
    "faire-du-shopping",
    "le-week-end",
    "le-petit-dejeuner",
    "le-dejeuner",
    "le-diner",
    "en-avoir-marre",
    "sympa",
    "ca-va",
    "sortir-avec",
    "pote-ami",
    "cool",
    "boulot-job",
    "blague",
    "c-est-cool",
    "je-vais-faire-du-shopping",
    "tu-viens",
    "bien",
    "tres",
    "c-est-tres-bon",
    "la-bise"
  ],
  "como-pronunciar-r-frances-21-dias": [
    "rue",
    "rat",
    "rire",
    "paris"
  ],
  "vocabulario-viagem-franca-15-dias": [
    "bonjour",
    "excusez-moi-je-ne-parle-pas-francais",
    "parlez-vous-anglais",
    "un-peu",
    "ou-sont-les-taxis-le-metro-les-toilettes",
    "merci-beaucoup",
    "j-ai-une-reservation-au-nom-de",
    "le-petit-dejeuner-est-inclus",
    "a-quelle-heure-est-le-check-out",
    "il-n-y-a-pas-d-eau-chaude",
    "la-climatisation-ne-marche-pas",
    "pouvez-vous-appeler-un-taxi",
    "un-cafe-allonge-s-il-vous-plait",
    "une-baguette-s-il-vous-plait",
    "un-pain-au-chocolat",
    "une-chocolatine",
    "quelle-est-la-formule-du-jour",
    "une-carafe-d-eau",
    "saignant-a-point-bien-cuit",
    "l-addition-s-il-vous-plait",
    "je-paie-par-carte",
    "un-carnet-de-dix-tickets",
    "cette-ligne-va-a",
    "quel-arret-pour-la-tour-eiffel",
    "le-dernier-train-part-a-quelle-heure",
    "le-train-est-en-retard",
    "pardon-je-descends-ici",
    "combien-ca-coute",
    "c-est-trop-cher",
    "vous-acceptez-les-cartes",
    "est-ce-que-vous-avez-ca-en-taille-m",
    "je-peux-essayer",
    "je-vais-reflechir",
    "un-sac-s-il-vous-plait",
    "un-billet-s-il-vous-plait",
    "tarif-etudiant-senior",
    "a-quelle-heure-ca-ouvre-ferme",
    "pouvez-vous-me-prendre-en-photo",
    "c-est-magnifique",
    "au-secours",
    "j-ai-besoin-d-un-medecin",
    "ou-est-l-hopital-le-plus-proche",
    "j-ai-perdu-mon-passeport",
    "j-ai-ete-vole-e",
    "appelez-la-police-s-il-vous-plait",
    "bonjour-excusez-moi-je-ne-parle-pas-tres-bien-francais",
    "attirer",
    "pretendre",
    "je-compte",
    "je-vais",
    "rester",
    "je-reste-a-paris",
    "s-entrainer",
    "assister-a",
    "assister-au-film"
  ],
  "10-frases-aeroporto-charles-de-gaulle": [
    "bonjour-je-suis-en-voyage-de-tourisme",
    "bonjour",
    "je-suis-en-voyage-d-affaires",
    "je-reste-dix-jours-en-france",
    "quinze-jours",
    "trois-semaines",
    "voici-mon-passeport-et-mon-billet-retour",
    "excusez-moi-ou-est-le-tapis-numero-cinq",
    "le-tapis",
    "cinq",
    "ma-valise-n-est-pas-arrivee",
    "ma-valise",
    "n-est-pas-arrivee",
    "bagage",
    "bonjour-combien-pour-aller-au-centre-de-paris",
    "c-est-cinquante-cinq-euros-c-est-ca",
    "je-voudrais-aller-a-cette-adresse-s-il-vous-plait",
    "cette-adresse",
    "un-billet-pour-paris-centre-s-il-vous-plait",
    "paris-par-train",
    "est-ce-que-ce-train-va-bien-a-chatelet",
    "excusez-moi-ou-sont-les-toilettes",
    "les-toilettes",
    "livraison-bagages",
    "sortie",
    "controle-passeport",
    "douane",
    "rien-a-declarer",
    "je-ne-comprends-pas",
    "vous-parlez-anglais",
    "pouvez-vous-repeter-s-il-vous-plait"
  ],
  "20-girias-parisienses-2026": [
    "wesh",
    "balec",
    "salut",
    "wesh-rak",
    "wesh-mec-ca-va",
    "kiffer",
    "kif",
    "je-kiffe-cette-chanson",
    "grave",
    "c-est-grave-bien",
    "ouf",
    "fou",
    "c-etait-un-truc-de-ouf",
    "chelou",
    "louche",
    "le-mec-est-chelou",
    "relou",
    "lourd",
    "t-es-relou",
    "cette-reunion-est-relou",
    "venere",
    "enerve",
    "il-est-venere",
    "ca-me-venere",
    "meuf",
    "femme",
    "la-meuf-de-paul",
    "cette-meuf-est-cool",
    "mec",
    "ce-mec-est-fou",
    "pote",
    "mon-pote",
    "un-vieux-pote",
    "bosser",
    "je-dois-bosser-demain",
    "travailler",
    "ca-marche",
    "trop",
    "c-est-trop-bien",
    "tu-es-trop-mignonne",
    "genre",
    "genre-c-etait-fou",
    "truc",
    "passe-moi-ce-truc",
    "j-ai-un-truc-a-te-dire",
    "se-pieuter",
    "je-vais-me-pieuter",
    "avoir-la-dalle",
    "j-ai-la-dalle",
    "ca-caille",
    "bah-ca-caille-aujourd-hui",
    "bail",
    "caution",
    "c-est-quoi-ce-bail",
    "un-bon-bail",
    "ce-n-est-pas-grave",
    "tu-me-manques",
    "bon-appetit",
    "sympa",
    "ca-va"
  ],
  "falsos-amigos-frances-12-palavras": [
    "salir",
    "attendre",
    "repondre",
    "j-attends-le-bus",
    "constipe",
    "enrhume",
    "je-suis-enrhume",
    "j-ai-le-rhume",
    "pourtant",
    "donc",
    "il-pleut-pourtant-je-sors",
    "sortir",
    "ne-salis-pas-tes-chaussures",
    "esquisse",
    "une-esquisse",
    "bizarre",
    "etrange",
    "j-ai-fait-une-esquisse-du-dessin",
    "pretendre",
    "avoir-l-intention-de",
    "il-pretend-etre-medecin",
    "injurier",
    "il-m-a-injurie",
    "embrasser",
    "serrer-dans-les-bras",
    "faire-un-calin",
    "il-a-embrasse-sa-copine",
    "quitter",
    "payer",
    "regler",
    "je-quitte-paris-demain",
    "repetition",
    "j-ai-une-repetition-ce-soir",
    "la-repetition-du-mot",
    "rester",
    "il-reste",
    "je-vais-rester-la-nuit",
    "il-ne-me-reste-que-10-euros",
    "le-poste",
    "la-poste",
    "ah-tu-voulais-dire",
    "assister-a",
    "achever",
    "conference",
    "reunion",
    "location",
    "emplacement",
    "passer",
    "je-vais-passer-chez-toi"
  ],
  "cognatos-verdadeiros-frances-30-palavras": [
    "hopital",
    "habite",
    "chocolat",
    "le-probleme",
    "la-mer",
    "litterature",
    "je",
    "tu",
    "il-elle",
    "c-est",
    "c-est-fantastique",
    "le-restaurant-est-moderne",
    "le-probleme-est-difficile"
  ],
  "10-erros-brasileiros-aprendendo-frances": [
    "je-voudrais",
    "il-y-a",
    "est-ce-que",
    "j-ai-faim",
    "ca-marche-pas",
    "constitution",
    "chocolat",
    "paris",
    "fromage"
  ],
  "viver-um-dia-em-paris": [
    "artisan-boulanger",
    "bonjour-un-cafe-allonge-et-une-chocolatine-s-il-vous-plait",
    "menu-du-jour",
    "une-carafe-d-eau-s-il-vous-plait",
    "saignant-a-point-bien-cuit",
    "l-addition-quand-vous-voulez",
    "un-verre-de-blanc-et-une-planche-s-il-vous-plait",
    "sante",
    "vin-de-la-maison",
    "je-vous-prends-ca",
    "ca-marche",
    "c-est-note",
    "pas-de-souci",
    "de-rien",
    "on-y-va",
    "je-file",
    "bonjour",
    "s-il-vous-plait",
    "merci"
  ],
  "7-expressions-francaises": [
    "il-pleut-des-cordes",
    "couter-les-yeux-de-la-tete",
    "avoir-le-cafard",
    "j-ai-le-cafard-aujourd-hui",
    "poser-un-lapin",
    "elle-m-a-pose-un-lapin",
    "avoir-un-coup-de-foudre",
    "c-est-la-fin-des-haricots",
    "mettre-son-grain-de-sel"
  ],
  "7-erros-mais-comuns-brasileiros": [
    "tu",
    "salut-tu-vas-bien",
    "bon",
    "bonne",
    "an",
    "annee",
    "femme",
    "beaucoup",
    "tres",
    "tres-beau",
    "tres-vite",
    "tres-bien",
    "beaucoup-de",
    "j-aime-beaucoup",
    "beaucoup-de-monde",
    "je-suis-tres-content",
    "il-fait-tres-chaud",
    "j-ai-25-ans",
    "etre",
    "se-debrouiller",
    "trouver-une-solution",
    "faire-une-gaffe",
    "se-planter",
    "se-ridiculiser",
    "avoir-honte",
    "avoir-du-culot",
    "etre-culotte",
    "envoyer-tout-balader",
    "tout-plaquer",
    "probleme"
  ]
};
